import { Component, inject, OnInit } from "@angular/core";
// import { RemoteConfig } from "@angular/fire/remote-config";
import { SplashScreen } from "@awesome-cordova-plugins/splash-screen/ngx";
import { StatusBar } from "@awesome-cordova-plugins/status-bar/ngx";
import { IonApp, IonRouterOutlet, MenuController, Platform } from "@ionic/angular/standalone";
// import { PwaService } from '@hssa-itasia/ngx-util-core';
import { BaseInjectorService } from "src/app/base/base-service.injecter";
import { environment } from "src/environments/environment";
import { SharedModule } from "./shared.module";
import { LhTableComponent } from "./components/lh-table/lh-table.component";
import { HeaderMenuModule } from "./components/header-menu/header-menu.module";

declare var window;
declare var google;
@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    styleUrls: ["app.component.scss"],
    providers: [SplashScreen],
    imports: [IonApp, IonRouterOutlet, SharedModule, HeaderMenuModule],
})
export class AppComponent extends BaseInjectorService implements OnInit {
  authState = { loggedIn: false };
  loading = false;
  menuFlag = false;
  userRole;
  public menuData = {
    user: "",
    appPages: [],
  };
  public authData = {
    TOKEN: "",
    EMAIL: "",
    USER_NAME: "",
    USER_ROLE: "",
  };
  isUserLoggedIn = false;
  public transporterMenu = [
    {
      title: "Dashboard",
      url: "/dashboard",
      visibility: true,
    },
    {
      title: "Outbound Trips",
      url: "/outbound-trips",
      visibility: true,
    },
    {
      title: "Carrier Income Statements",
      url: "/rcti-statement",
      visibility: true,
    },
  ]; 
  public plantuserMenu = [
    {
      title: "Dashboard",
      url: "/dashboard",
      visibility: true,
    },
    {
      title: "Outbound Trips",
      url: "/humes-deliveries",
      visibility: true,
    },
    {
      title: "Vendor Master",
      url: "/transporter-master",
      visibility: true,
    },
    {
      title: "Driver Master",
      url: "/driver-master",
      visibility: true,
    },
  ];
  public superAdminMenu = [
    {
      title: "Dashboard",
      url: "/dashboard",
      visibility: true,
    },
    {
      title: "Outbound Trips",
      url: "/outbound-trips",
      visibility: true,
    },
    {
      title: "Humes - Outbound Trips",
      url: "/humes-deliveries",
      visibility: true,
    },
    {
      title: "Vendor Master",
      url: "/transporter-master",
      visibility: true,
    },
    {
      title: "Truck Master",
      url: "/truck-master",
      visibility: true,
    },
    {
      title: "Driver Master",
      url: "/driver-master",
      visibility: true,
    },
    {
      title: "Mapping Master",
      url: "/mapping-master",
      visibility: true,
    },
    {
      title: "Plant Master",
      url: "/plant-master",
      visibility: true,
    },
    {
      title: "Carrier Income Statements",
      url: "/rcti-statement",
      visibility: true,
    },
    {
      title: "Change History",
      url: "/audit-history",
      visibility: true,
    },
    // {
    //   title: 'Epod Pdf',
    //   url: '/epod-pdf',
    //   visibility: true
    // }
  ];
  // private remoteConfig=inject(RemoteConfig);
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private menuCtrl: MenuController
    // private remoteConfig: AngularFireRemoteConfig // private pwaServiceUtil: PwaService
  ) {
    super();        
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleDefault();
      this.splashScreen.hide();
      this.analytics.gaEnableAnalytics(true);
      // this.pwaServiceUtil.initPwaServices();
      this.setUserProfile();
      this.eventSevice.getAuthState().subscribe(async (data) => {
        console.log("auth state data:", data);
        if (data && data.loggedIn) {
          // User is logged in, check if we have user info from storage
          const userData = await this.auth.getUserInfo();
          if (userData && userData['EMAIL']) {
            // User has valid session, navigate to dashboard
            this.router.navigate(["/dashboard"]);
          } else {
            // No valid session, go to login
            this.onLoginApply();
            this.router.navigate(["/login"]);
          }
        } else {
          // Not logged in, go to login
          this.onLoginApply();
          this.router.navigate(["/login"]);
        }
      });
      this.auth.getUserInfo().then((userData) => {
        console.log("USER DATA", userData);
        this.menuData.user = userData ? userData["USER_NAME"] : "User";
        this.userRole = userData ? userData["USER_ROLE"] : "";
      });
      this.auth.isLoggedIn().then((data) => {
        this.isUserLoggedIn = data;
      });
      this.eventSevice.getUserLogout().subscribe((data) => {
        if (data) {
          this.onLoginApply();
        }
      });
      this.eventSevice.getUsersRole().subscribe((userRole) => {
        console.log("User role", userRole);
        this.menuCtrl.enable(true);
        if (userRole === "ROLE_SUPERADMIN") {
          this.menuData.appPages = this.superAdminMenu;
          this.menuFlag = true;
        } else if (userRole === "ROLE_USER") {
          this.menuData.appPages = this.superAdminMenu.filter((el)=>el.url != "/humes-deliveries");
          this.menuFlag = true;
          console.log("HERE");
          console.log( this.menuData.appPages)
        } else if (userRole === "ROLE_TRANSPORTER") {
          this.getStorageData("transporterProfile").then(
            async (data) => {
              console.log("transporterId profile:::", data);
              if (data && data["transporterId"]) {
                console.log(data["businessUnit"]);
                if (data["businessUnit"] == "HUMES") {
                  console.log("in iff ", this.transporterMenu);
                  // this.transporterMenu = this.transporterMenu.splice(0, 2);
                  // this.transporterMenu = this.transporterMenu.splice(0, 1);
                  // this.transporterMenu.push({
                  //   title: "Humes - Outbound Trips",
                  //   url: "/humes-deliveries",
                  //   visibility: true,
                  // });

                  
                  this.transporterMenu.splice(1,1,{
                    title: "Humes - Outbound Trips",
                    url: "/humes-deliveries",
                    visibility: true,
                  });


                }            
                await this.transporterMenu.map((el) =>
                  el.url == "/rcti-statement"
                    ? { ...el, transporterId: data["transporterId"] }
                    : el
                );
                await this.transporterMenu.filter((el) => {
                  if (el && el.url === "/rcti-statement")
                    el["queryParams"] = {
                      transporterId: data["transporterId"],
                    };
                });
                await console.log(
                  "this.transporterMenu:",
                  this.transporterMenu
                );
                this.menuData.appPages = await this.transporterMenu;
                this.menuFlag = true;
              } else {
                console.log("in elese");
                this.menuData.appPages = this.transporterMenu;
                this.menuFlag = true;
              }
            },
            (error) => {
              this.menuData.appPages = this.transporterMenu;
              this.menuFlag = true;
            }
          );
        } else if (userRole == "PLANT_USER") {
          console.log("in if======");
          this.menuData.appPages = this.plantuserMenu;
          this.menuFlag = true;
        } else {
          this.menuData.appPages = [];
          this.menuFlag = true;
        }
      });
      this.assignMenus();
      this.fetchRemoteConfig();
    });
  }

  validateUser(email) {
    return new Promise(async (resolve) => {
      var idx = await email.lastIndexOf("@");
      const emailDomain = (await idx) > -1 && email.slice(idx + 1);
      if (emailDomain && emailDomain.toLowerCase() === "holcim.com") {
        resolve(true);
      } else {
        resolve(false);
      }
    }).catch((e) => {
      console.log("Promise failure validateUser: ", e);
      throw new Error("Promise failure validateUser");
    });
  }

  onLoginApply() {
    this.auth.clearSession();
    this.menuFlag = false;
    this.menuCtrl.enable(false);
  }
  logout() {
    try {
      // Use the new Google Identity Services approach
      if (typeof google !== 'undefined' && google.accounts && google.accounts.id) {
        google.accounts.id.disableAutoSelect();
        google.accounts.id.revoke(this.authData.EMAIL, () => {
          console.log('Google account access revoked');
        });
      }
      this.eventSevice.emitAuthState({ loggedIn: false });
    } catch (error) {
      console.error('Error during logout:', error);
      this.eventSevice.emitAuthState({ loggedIn: false });
    }
  }

  async assignMenus() {
    console.log("assign menu called");
    await this.auth.isLoggedIn().then((data) => {
      this.isUserLoggedIn = data;
    });
    await this.auth.getUserInfo().then((userData) => {
      this.menuData.user = userData ? userData["USER_NAME"] : "User";
      this.userRole = userData ? userData["USER_ROLE"] : "";
    });
    if (this.isUserLoggedIn) {
      this.menuCtrl.enable(true);
      if (this.userRole === "ROLE_SUPERADMIN") {
        this.menuData.appPages = this.superAdminMenu;
        this.menuFlag = true;
      } else if (this.userRole === "ROLE_USER") {
        this.menuData.appPages = this.superAdminMenu.filter((el)=>el.url != "/humes-deliveries");
        console.log("HERE 2");
        console.log( this.menuData.appPages)
        this.menuFlag = true;
      } else if (this.userRole === "ROLE_TRANSPORTER") {
        this.getStorageData("transporterProfile").then(
          async (data) => {
            console.log("transporterId profile:::", data);
            if (data && data["transporterId"]) {
              console.log(data["businessUnit"]);
              if (data["businessUnit"] == "HUMES") {
                console.log("in iff");
                // this.transporterMenu = this.transporterMenu.splice(0, 2);
                // this.transporterMenu = this.transporterMenu.splice(0, 1);
                // this.transporterMenu.push({
                //   title: "Humes - Outbound Trips",
                //   url: "/humes-deliveries",
                //   visibility: true,
                // });
                     
                this.transporterMenu.splice(1,1,{
                  title: "Humes - Outbound Trips",
                  url: "/humes-deliveries",
                  visibility: true,
                });

              }
              await this.transporterMenu.map((el) =>
                el.url == "/rcti-statement"
                  ? { ...el, transporterId: data["transporterId"] }
                  : el
              );
              await this.transporterMenu.filter((el) => {
                if (el && el.url === "/rcti-statement")
                  el["queryParams"] = { transporterId: data["transporterId"] };
              });
              await console.log("this.transporterMenu:", this.transporterMenu);
              this.menuData.appPages = await this.transporterMenu;
              this.menuFlag = true;
            } else {
              this.menuData.appPages = this.transporterMenu;
              this.menuFlag = true;
            }
          },
          (error) => {
            this.menuData.appPages = this.transporterMenu;
            this.menuFlag = true;
          }
        );
      } else if (this.userRole == "PLANT_USER") {
        console.log("in if======");
        this.menuData.appPages = this.plantuserMenu;
        this.menuFlag = true;
      } else {
        this.menuData.appPages = [];
        this.menuFlag = true;
      }
    }
  }

  fetchRemoteConfig() {
    // this.remoteConfig.booleans.enable_rc_changes.subscribe(async (status) => {
    //   this.baseHttp.enable_RC = status;
    // });
  }

  async setUserProfile() {
    const userProfile = await this.auth.getUserInfo();
    if (userProfile && userProfile["EMAIL"]) {
      this.analytics.gaSetUserOnReload(userProfile["EMAIL"]);
      if (
        userProfile["USER_ROLE"] &&
        userProfile["USER_ROLE"] == "ROLE_TRANSPORTER"
      ) {
        await this.auth
          .fetchProfile(userProfile["EMAIL"])
          .then((profileData) => {
            profileData && this.storage.set("transporterProfile", profileData);
          });
      }
    }
  }
}
